import type { RouteRecordRaw } from "vue-router"

import { ProveRoutes } from "./prove/routes"
import { AccountLookupRoutes } from "./account-lookup/routes"
import { ApplicationTypeSelectionRoutes } from "./application-type-selection/routes"
import { SalesAssociateCollectionRoutes } from "./salesAssociateCollection/routes"
import { StateLookupRoutes } from "./state-lookup/routes"
import { useLocaleStore, useSessionStore } from "@versatile-credit-apply/sdk"
import { useApplyNavigationPath } from "@/composition"

export const WorkflowRoutes: RouteRecordRaw[] = [
  {
    path: "workflows",
    children: [
      {
        path: "pre-provider",
        children: [
          {
            path: "",
            redirect: (to) => {
              const sessionStore = useSessionStore()
              const localeStore = useLocaleStore()

              const extensions =
                sessionStore.findExtensionsByFlowPosition("pre_provider")

              if (extensions.length) {
                // The ID is the path
                return to.fullPath.replace(
                  "pre-provider",
                  extensions[0].featureId
                )
              }

              // No extensions to run
              return `/${sessionStore.flowType}/groups/${localeStore.group}/start`
            },
          },
        ],
      },
      {
        path: "pre-application",
        children: [
          {
            path: "",
            redirect: (to) => {
              const sessionStore = useSessionStore()

              const extensions =
                sessionStore.findExtensionsByFlowPosition("pre_application")

              if (extensions.length) {
                return to.fullPath.replace(
                  "pre-application",
                  extensions[0].featureId
                )
              }

              // No pre application extensions to run
              return useApplyNavigationPath(() => "application").value
            },
          },
        ],
      },
      {
        path: ":id/next",
        redirect: (to) => {
          const sessionStore = useSessionStore()
          const localeStore = useLocaleStore()

          const id = to.params.id as string

          const extension = sessionStore.findExtensionById(id)
          if (!extension) {
            throw new Error(`Unable to find extension with id=${id}`)
          }

          if (extension.flowPosition == undefined) {
            throw new Error(`Extension is not routable id=${id}`)
          }

          const extensions = sessionStore.findExtensionsByFlowPosition(
            extension.flowPosition
          )

          const nextExtensions = extensions.slice(
            extensions.findIndex(
              (other) => other.featureId === extension.featureId
            ) + 1
          )

          // Go to the next extension
          if (nextExtensions.length) {
            return `/apply/workflows/${nextExtensions[0].featureId}`
          }

          switch (extension.flowPosition) {
            case "pre_provider":
              return `/${sessionStore.flowType}/groups/${localeStore.group}/start`
            case "pre_application":
            default:
              return useApplyNavigationPath(
                () => (to.query?.continueTo as string) ?? "application"
              ).value
          }
        },
      },
      ...ApplicationTypeSelectionRoutes,
      ...SalesAssociateCollectionRoutes,
      ...ProveRoutes,
      ...AccountLookupRoutes,
      ...StateLookupRoutes,
    ],
  },
]
